// umiAPI/React
import { useState } from 'react';
import { useModel } from 'umi';

// 枚举
import { CoinTypeEnum } from '@/enums/businessEnum';
// api
import { getIndexApi } from '@/services/api/requestApi';
import { useReq } from '@/services/net/request';
//
import { useTranslation } from 'react-i18next';

export default function () {
    const { t } = useTranslation();

}